// extracted by mini-css-extract-plugin
module.exports = {"root":"CompanyBox_root__8pH7y","instructionsBox":"CompanyBox_instructionsBox__1V-Vp","instructions":"CompanyBox_instructions__21nSI"};